// One line under a listed LST's holding (docs/19-staking-plan.md section 3.4 item 3): what the balance is worth in
// SOL at the pool's own on-chain rate, labelled an estimate. Nothing renders for any other token; a read that fails
// says so instead of showing a number.
import { useEffect, useState } from 'react';
import { describe } from '../engine';
import { type LstValue, isListedLst, readLstValue } from '../lst';
import type { Rpc } from '../rpc';
import { Amount } from './primitives';

export function LstValueLine({ rpc, mint, amount }: { rpc: Pick<Rpc, 'getMultipleAccounts'>; mint: string; amount: bigint }) {
  const listed = isListedLst(mint);
  const [value, setValue] = useState<LstValue | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!listed) return;
    let live = true;
    readLstValue(rpc, mint, amount).then(
      (v) => {
        if (live) {
          setValue(v);
          setError(null);
        }
      },
      (e) => {
        if (live) setError(describe(e));
      },
    );
    return () => {
      live = false;
    };
  }, [rpc, mint, amount, listed]);
  if (!listed) return null;
  if (error) return <small className="lst-value">The value in SOL could not be read from the pool: {error}</small>;
  if (!value) return null;
  const symbol = value.pool.symbol;
  return (
    <small className="lst-value" data-lst={symbol}>
      Worth about <Amount raw={value.lamports} decimals={9} symbol="SOL" maxFraction={6} />, an estimate from the {symbol} pool&rsquo;s own accounts, not a price you can sell at.
      {value.estimate ? ` The ${symbol} figure is read by this app from a layout ${symbol}'s issuer has not confirmed.` : ''}
    </small>
  );
}
